export default {
  state: {
    admins: {   
      headers: [
        { text: 'First Name', align: 'center', sortable: false, value: 'first_name' },
        { text: 'Last Name', align: 'center', sortable: false, value: 'last_name' },
        { text: 'Email', align: 'center', sortable: false, value: 'email' },
        { text: 'Actions', align: 'center', sortable: false, value: 'actions' }
      ],
      students: [],
      records: []
    },
    technicians:{
      headers:[
        { text: 'First Name', align: 'center', sortable: false, value: 'first_name' },
        { text: 'Last Name', align: 'center', sortable: false, value: 'last_name' },
        { text: 'Email', align: 'center', sortable: false, value: 'email' },
        { text: 'Actions', align: 'center', sortable: false, value: 'actions' }
      ],
      records:[]
    },
    users:{
      headers:[
        // { text: 'First Name', align: 'center', sortable: false, value: 'first_name' },
        // { text: 'Last Name', align: 'center', sortable: false, value: 'last_name' },
        { text: 'Email', align: 'center', sortable: false, value: 'email' },
        { text: 'Actions', align: 'center', sortable: false, value: 'actions' }
      ],
      records:[],
      roles: [],
      statuses: [],
    },
      types: [],
    editUser: null,  
    editAdmin: null,
  },
  getters: {    
    filterByAdmin: (state) => {
      var records = [];
      for (var i=0; i<state.admins.records.length; i++) {
        if(state.admins.records[i].role == 2){
          records.push(state.admins.records[i]);
        }
      }
      return records;
    },
    filterByUser: (state) => {
      var records = [];
      for (var i=0; i<state.users.records.length; i++) {
        // if(state.users.records[i].role == 4){
          records.push(state.users.records[i]);
        // }
      }
      return records;
    },
      filterStudents: (state) => {
      var records = [];
      for (var i=0; i<state.admins.students.length; i++) {
        // if(state.users.records[i].role == 4){
          records.push(state.admins.students[i]);
        // }
      }
      return records;
    },
    getUserRoles: (state) =>{
      var list = [];
      for (var i=0; i<state.users.roles.length; i++) {
        list.push(state.users.roles[i]);
      }
      // console.log("Make list", list);
      return list;
    },
    getUserStatuses: (state) =>{
      var list = [];
      for (var i=0; i<state.users.statuses.length; i++) {
        list.push(state.users.statuses[i]);
      }
      // console.log("Make list", list);
      return list;
    },
    technicianList: (state) => {
      return state.technicians.records.map(technician => ({email: technician.email , full_name: technician.first_name + ' ' + technician.last_name}))
    },
    getUserTypes: (state) =>{
      var list = [];
      for (var i=0; i<state.types.length; i++) {
          list.push(state.types[i]);
      }
      console.log("user types length", list.length);
      console.log("user types list", list);
      return list;
    },
  },
  mutations: {
    setUsers (state, data){
      state.users.records = data
    },
    editUser (state, data){
      state.editUser = data
    },
    setAdmins (state, data){
      state.admins.records = data
    },
    editAdmin (state, data){
      state.editAdmin = data
    },
    setUserRoles (state, data){
      state.users.roles = data
    },
    setUserStatuses (state, data){
      state.users.statuses = data
    },
    adminStudents (state, data){
      state.admins.students = data
    },
    userTypes (state, data){
      state.types = data
    },
  },
  actions: {       
    setUsers ({commit}, data){
      commit('setUsers', data)
    },
    editUser ({commit}, data){
      commit('editUser', data)
    },
    setAdmins ({commit}, data){
      commit('setAdmins', data)
    },
    editAdmin ({commit}, data){
      commit('editAdmin', data)
    },
    setUserRoles ({commit}, data){
      commit('setUserRoles', data)
    },
    setUserStatuses ({commit}, data){
      commit('setUserStatuses', data)
    },
    setAdminStudents ({commit}, data){
      commit('adminStudents', data)
    },
    setUserTypes ({commit}, data){
      commit('userTypes', data)
    },
  }
}